const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	picture_libraries : [],
	current_picture_library : null,
}

const getters = {
	fetchPictureLibraries : (state) => state.picture_libraries,
	fetchCurrentPictureLibrary : (state) => state.current_picture_library,
}

const actions = {
	loadPictureLibraries({commit}, {token}){
		return $http.get(`picturelibrary`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_PICTURE_LIBRARIES', response.data)
		})
	},

	loadCurrentPictureLibrary({commit}, {id, token}){
		return $http.get(`picturelibrary/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_PICTURE_LIBRARY', response.data)
		})
	},

	createPictureLibrary({commit}, {picture_library, token}){
		let picture_library_formdata = new FormData()
		for(let key in picture_library){
			picture_library_formdata.append(key, picture_library[key])
		}
		
		return $http.post('picturelibrary', picture_library_formdata, {
			headers : {
				'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_PICTURE_LIBRARY', response.data)
		})
	},

	updatePictureLibrary({commit}, {id, picture_library, token}){
		let picture_library_formdata = new FormData()
		for(let key in picture_library){
			if(key == 'editfile'){
				picture_library_formdata.append(key, JSON.stringify(picture_library[key]))
			}else{
				picture_library_formdata.append(key, picture_library[key])
			}	
		}
		
		return $http.put(`picturelibrary/${id}`, picture_library_formdata, {
			headers : {
				'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_PICTURE_LIBRARY', response.data)
		})
	},

	deletePictureLibrary({commit}, {id, token}){
		return $http.delete(`picturelibrary/${id}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then((response) => {
			if(response.data.n > 0){
				commit('REMOVE_PICTURE_LIBRARY', id)	
			}
		})
	},
}

const mutations = {
	SET_PICTURE_LIBRARIES : (state, picture_libraries) => {
		state.picture_libraries = picture_libraries
	},
	SET_CURRENT_PICTURE_LIBRARY : (state, picture_library) => {
		state.current_picture_library = picture_library
	},
	ADD_PICTURE_LIBRARY : (state, picture_library) => {
		state.picture_libraries.push(picture_library)
	},
	UPDATE_PICTURE_LIBRARY : (state, picture_library) => {
		state.current_picture_library = picture_library
	},
	REMOVE_PICTURE_LIBRARY : (state, picture_library_id) => {
		const picture_library_index = state.picture_libraries.map((picture_library) => picture_library._id).indexOf(picture_library_id)
		state.picture_libraries.splice(picture_library_index, 1)
	},
}

export default {
	state, getters, actions, mutations
}